<template>
    <div>
        <van-nav-bar class="nav-bar" title="资源购买确认信息" left-text="返回" left-arrow @click-left="$router.push({path:'/'})" />
        
        <div>
            <div class="confirm-title">资源信息</div>
            <van-form>
                <van-field v-model="confirmData.resourceName" name="资源名称" label="资源名称" placeholder="请输入资源名称" readonly />
                <van-field v-model="confirmData.cpuCore" name="CPU核心数" label="CPU核心数" placeholder="请输入CPU核心数" readonly />
                <van-field v-model="confirmData.cpuCore" name="内存容量" label="内存容量" placeholder="请输入内存容量" readonly />
                <van-field v-model="confirmData.hardDisk" name="硬盘容量" label="硬盘容量" placeholder="请输入硬盘容量" readonly />
                <van-field v-model="confirmData.model" name="型号" label="型号" placeholder="请输入型号" readonly />
                <van-field v-model="confirmData.cardsNum" name="卡数" label="卡数" placeholder="请输入卡数" readonly />
                <van-field v-model="confirmData.networking" name="组网" label="组网" placeholder="请输入组网" readonly />
                <van-field v-model="confirmData.rentableNum" name="可租台数" label="可租台数" placeholder="请输入可租台数"/>
                <van-field v-model="confirmData.address" name="地点" label="地点" placeholder="请输入地点" readonly />
                <!-- <van-field v-model="confirmData.linkPhone" name="资源状态" label="资源状态" placeholder="请输入资源状态" readonly /> -->
                <van-field v-if="confirmData.rentOn == 1" label="资源状态" value="随时可租" readonly />
                <van-field v-if="confirmData.rentOn == 2" label="资源状态" value="指定日期可租" readonly />
                <van-field v-show="confirmData.rentOn == 2" v-model="confirmData.rentDate" name="可租日期" label="可租日期" placeholder="请输入可租日期" readonly />
                <van-field v-if="confirmData.monthRent != null" v-model="confirmData.monthRent" name="月租金额" label="月租金额" placeholder="请输入月租金额" readonly />
                <van-field v-else-if="confirmData.yearRent != null" v-model="confirmData.yearRent" name="年租金额" label="年租金额" placeholder="请输入年租金额" readonly />
                <!-- <van-field v-model="confirmData.resourceDesc" name="资源描述" label="资源描述" placeholder="请输入资源描述" readonly /> -->
                <!-- <van-field v-model="confirmData.remark" name="备注" label="备注" placeholder="请输入备注" readonly /> -->
                <van-field
                    v-model="confirmData.resourceDesc"
                    rows="2"
                    autosize
                    label="资源描述"
                    type="textarea"
                    placeholder="请输入资源描述"
                />
                <van-field
                    v-model="confirmData.remark"
                    rows="2"
                    autosize
                    label="备注"
                    type="textarea"
                    placeholder="请输入备注"
                />
            </van-form>
            <div class="confirm-title">用户信息</div>
             <van-form >
                <van-field v-model="order.rentableNum" name="租用台数" label="租用台数" placeholder="请输入租用台数"/>
                <van-field name="radio" label="租用类型">
                    <template #input v-if="confirmData.monthRent != null ">
                        <van-radio-group v-model="order.rentType" direction="horizontal" label="租用类型" >
                            <van-radio name="1">按月租用</van-radio>
                            <van-radio name="2" disabled>按年租用</van-radio>
                        </van-radio-group>
                    </template>
                    <template #input v-else>
                        <van-radio-group v-model="order.rentType"  direction="horizontal" label="租用类型">
                            <van-radio name="1" disabled>按月租用</van-radio>
                            <van-radio name="2">按年租用</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                
                <!-- <van-field v-model="order.rentDate" name="租用日期" label="租用日期" placeholder="请选择租用日期" /> -->
                <van-field
                    readonly
                    clickable
                    name="picker"
                    right-icon="arrow"
                    :value="order.rentDate"
                    label="租用日期"
                    placeholder="请选择租用日期"
                    @click="showPickerDate = true"
                />
                <van-popup v-model="showPickerDate" position="bottom">
                    <van-datetime-picker
                        show-toolbar
                        type="date"
                        title="选择年月日"
                        :min-date="minDate" 
                        :max-date="maxDate"
                        :formatter="formatter"
                        @confirm="onConfirmDate"
                        @cancel="showPickerDate"
                    />
                </van-popup>
                <van-field v-model="order.rentTime" name="租用时长" label="租用时长" placeholder="请输入租用时长" >
                    <template #right-icon>
                        <span v-if="order.rentType == 1">月</span>
                        <span v-else>年</span>
                    </template>
                </van-field>  
                <van-field v-model="confirmData.resourceLinkName" name="联系人" label="联系人" placeholder="请输入联系人" />
                <van-field v-model="confirmData.resourceLinkPhone" name="联系方式" label="联系方式" placeholder="请输入联系方式" />
                
                
                <van-button class="submit-button" round block type="info" native-type="submit" @click="confirmBuy">提 交</van-button>
            </van-form>
        </div>
    </div>
</template>

<script>
import {
    resourceBuyConfirm,
    resourceBuy
} from '@/api/index'
import { Toast,Dialog  } from 'vant';
export default {
    data() {
        return {
            buyData:JSON.parse(sessionStorage.getItem('buyData')),
            confirmData:{},
            order:{
                rentableNum:1,
                rentType:'1',
                rentDate:'',
                rentTime:'1',//不论月租or年租 默认是1月或1年
            },
            minDate:new Date(2024, 0, 1),
            maxDate: new Date(2030, 12, 31),
            showPickerDate:false,
        };
    },

    mounted() {
        this.getConfirmMessage();

    },

    methods: {
        async getConfirmMessage(){
            let cloud_login_user_role = sessionStorage.getItem('cloud_login_user_role');//用户权限 /1个人需求 2公司需求 3资源 4渠道
            const data = await resourceBuyConfirm(cloud_login_user_role,this.buyData.flagId);
            if(data.success){
                this.confirmData = data.data;
                // 如果是有月租和年租 租用类型选择月租
                // 如果是只有年租 租用类型仅选择年租
                if(this.confirmData.monthRent != null ){
                    this.order.rentType = '1';
                }else if(this.confirmData.yearRent != null){
                    this.order.rentType = '2';
                }
            }
        },
        formatter (type, value) {
            if (type === 'year') {
                this.value1 = value   // 可以拿到当前点击的数值
                return `${value}年`
            } else if (type === 'month') {
                this.value2 = value
                return `${value}月`
            }
            this.value3 = value
            return `${value}日`
        },
        onConfirmDate(){
            this.order.rentDate = `${this.value1}-${this.value2}-${this.value3}`;
            this.showPickerDate = false;
        },
        confirmBuy(){
            let cloud_login_user_role = sessionStorage.getItem('cloud_login_user_role');//用户权限 /1个人需求 2公司需求 3资源 4渠道
            //判断 order.rentableNum 不能大于 confirmData.rentableNum
            if(this.order.rentableNum > this.confirmData.rentableNum){
                Toast.fail('租用台数不能大于可租用台数');
                return;
            }
            // order.rentableNum 不能小于1且为正整数 不能带小数点
            if(this.order.rentableNum < 1 || this.order.rentableNum % 1 != 0){
                Toast.fail('租用台数不能小于1且为正整数');
                return;
            }
            if(!this.order.rentDate){
                Toast.fail('请选择租用日期');
                return;
            }
            // rentOn = 2 时 起租日期 不能大于 可租日期
            if(this.order.rentType == 2){
                if(this.order.rentDate > this.confirmData.endDate){
                    Toast.fail('租用日期不能大于可租日期');
                    return;
                }
            }
            //正则验证手机号 
            if(!/^1[3456789]\d{9}$/.test(this.confirmData.resourceLinkPhone)){
                Toast.fail('手机号格式错误');
                return;
            }
            let data = {
                resourceBatch:this.confirmData.batchId,//资源批次id
                resourceNum:this.order.rentableNum,//购买资源台数
                unitPrice:this.confirmData.monthRent != null?this.confirmData.monthRent:this.confirmData.yearRent,// 资源单价
                timeLength:this.order.rentTime,//资源时长
                userType:cloud_login_user_role,//1 个人需求用户  2企业需求用户
                linkName:this.confirmData.resourceLinkName,//联系人
                linkPhone:this.confirmData.resourceLinkPhone,//联系人电话
                resourceName:this.confirmData.resourceName,//资源名称
                resourceDesc:this.confirmData.resourceDesc,//资源描述
                cpuCore:this.confirmData.cpuCore,//cpu核数
                memoryCapacity:this.confirmData.memoryCapacity,//内存容量
                hardDisk:this.confirmData.hardDisk,//硬盘容量
                address:this.confirmData.address,//地点
                model:this.confirmData.model,//型号
                cardsNum:this.confirmData.cardsNum,//卡数
                networking:this.confirmData.networking,//组网
                rentDate:this.order.rentDate,//计划租用日期
                rentType:this.order.rentType,//租用类型 1 按月租用 2 按年租用
            }
            resourceBuy(data).then(res=>{
                if (res.data) {
                    Dialog.alert({ 
                        title: '提示',
                        message: '购买申请已提交,请等待资源方联系确认',
                    }).then(() => {
                        this.$router.push({path:'/'});
                    });
                }
            })
        },
    },
};
</script>
<style scoped>
.confirm-title{
    width: 100%;
    height:3rem;
    font-size:1.25rem;
    line-height:3rem;
    padding-left:1rem;
    background-color: #EBEEF5;
}
.submit-button{
    width:90%;
    margin:20px auto;
}
</style>